import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ApiService } from '../services/api.service';
import { catchError, EMPTY, Observable } from 'rxjs';
import { PrivacyPolicy } from '../models/privacy-policy.model';
import { routes } from '../constants/routes';
import { NavigationService } from '../services/navigation.service';

export const privacyPolicyResolver: ResolveFn<PrivacyPolicy[]> = (
  state,
  route
): Observable<any> => {
  const apiService = inject(ApiService);
  const navigationService = inject(NavigationService)

  const routeUrl = route.url;
  let apiEndPoint = 'privacy_policy';

  if (routeUrl.includes(routes.individualPrivacy)) {
    apiEndPoint = 'individual_terms_and_conditions';
  } else if (routeUrl.includes(routes.orgPrivacy)) {
    apiEndPoint = 'org_terms_and_conditions';
  }

  return apiService.fetchPrivacyPolicy(apiEndPoint).pipe(
    catchError((error) => {
      navigationService.handleResolverError(error);
      return EMPTY;
    })
  );
};
